import { useSelector } from 'react-redux'

import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import {
  fetchCostObjects,
  getError,
  getIsDataLoaded,
  getIsPending,
} from '@/ducks/costObjectsReducer'
import { getCustomerId } from '@/ducks/customerReducer'

const withCostObjectsLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = true) =>
    // @ts-ignore
    props => {
      const customerId = useSelector(getCustomerId)

      return (
        <InitialLoadWrapper
          loadAction={fetchCostObjects}
          loadingSelector={getIsPending}
          // @ts-ignore
          loadedSelector={state => getIsDataLoaded(state, customerId)}
          errorSelector={getError}
          forceLoadOnMount={forceLoadOnMount}
          args={customerId}
        >
          <Component {...props} />
        </InitialLoadWrapper>
      )
    }

export default withCostObjectsLoaded
